import Vue from "vue";
import { postApi, post } from "@/utils/http";
import router from "@/router";
import { baseUrl } from "@/utils/settings";

export default {
  namespaced: true,
  state: {
    user: {},
    server: null,
    initiated: false,
    isLicenseConversionModalVisible: false,
    licenseInfo: null,
  },
  mutations: {
    setLicenseInfo(state, licenseInfo) {
      state.licenseInfo = licenseInfo;

      if (licenseInfo.free <= 5) state.isLicenseConversionModalVisible = true;
    },

    setLicenseConversionVisible(state, isLicenseConversionModalVisible) {
      state.isLicenseConversionModalVisible = isLicenseConversionModalVisible;
    },

    setInitiated(state, initiated) {
      state.initiated = initiated;
    },

    setServer(state, settings) {
      if (settings && settings.licenseEnabled === undefined)
        settings.licenseEnabled = true;

      state.server = settings;
      //console.log(settings);
    },

    setUser(state, { path, value }) {
      //console.log("setUser:", path, value);
      if (!state.user[path]) Vue.set(state.user, [path], {});
      Vue.set(state.user, [path], { ...state.user[path], ...value });
    },

    setUserSetting(state, { path, key, value }) {
      //console.log("setUserSetting:", path, key, value);
      if (!state.user[path]) Vue.set(state.user, [path], {});
      if (!state.user[path][key]) Vue.set(state.user[path], [key], {});

      //console.log(state.user[path][key]);

      if (typeof value === "object") {
        Vue.set(state.user[path], [key], {
          ...state.user[path][key],
          ...value,
        });
      } else Vue.set(state.user[path], [key], value);
    },
    clear(state) {
      state.user = {};
    },
  },
  actions: {
    async getLicenseStats({ commit }) {
      try {
        const data = await postApi("get/serverLicense", {
          withCredentials: true,
        });

        commit("setLicenseInfo", data);

        return data;
      } catch (error) {
        console.error("Could not get license stats", error);
      }
      return null;
    },

    async fetchServer({ commit }) {
      try {
        const res = await post(`${baseUrl}/get/settings`);

        const settings = res.data;
        commit("setServer", settings);

        if (settings.sealed && settings.webUnsealEnabled) {
          if (router.currentRoute.path != "/unavailable")
            router.push({ path: "/unavailable" });
          return false;
        } else if (settings.sealed && !settings.webUnsealEnabled) {
          if (router.currentRoute.path != "/unavailable")
            router.push({ path: "/unavailable" });
          return false;
        }
      } catch (e) {
        if (router.currentRoute.path != "/unavailable")
          router.push({ path: "/unavailable" });
        return false;
      }

      return true;
    },

    async fetchUserSetting({ state, commit }, path) {
      const response = await postApi("get/userSiteSetting", { key: path });
      //console.log("fetchUserSetting 1", path, typeof response);
      if (response && response[0] && response[0].value) {
        //console.log("fetchUserSetting 2", response[0]);
        if (response[0].value.startsWith("{")) {
          //console.log("fetchUserSetting 3", response[0]);
          commit("setUser", { path, value: JSON.parse(response[0].value) });
        } else {
          console.log("Got unparsable settings: ", path);
        }
      } else commit("setUser", { path, value: {} });
    },

    async getUserSetting({ dispatch, state, commit }, { path, key }) {
      //console.log("Action: getUserSetting:", path, key, state.user);
      if (!state.user[path]) await dispatch("fetchUserSetting", path);
      if (!state.user[path][key]) {
        commit("setUserSetting", { path, key, value: {} });
      }
      return state.user[path][key];
    },

    async getUserSettings({ dispatch, state }, { path }) {
      //console.log("Action: getUserSettings:", path, state.user);
      if (!state.user[path]) await dispatch("fetchUserSetting", path);
      return state.user[path];
    },

    async setUser({ state, commit }, { path, key, value }) {
      //console.log("setUser:", path, key, value);
      commit("setUserSetting", { path, key, value });
      // await postApi("set/userSiteSettings", {
      //   settings: { [path]: JSON.stringify({}) }
      // });
      await postApi("set/userSiteSettings", {
        settings: { [path]: JSON.stringify(state.user[path]) },
      });
    },
  },
  getters: {},
  modules: {},
};
